import React, { memo, useMemo } from "react";

import { CustomInput } from "components";
import { FieldWithReadOnlyMode } from "components/formFields";
import { hasPermissions, viewSensitiveDataFullPermissionSet } from "helpers";
import {
	exactNumberOfDigitsMask34,
	normalizeAll,
	required,
	trimNormalizer,
} from "validators";

type IBANFieldProps = {
	loading: boolean;
	value: string | undefined;
	isEditable: boolean;
};

const IBANField = ({ loading, value, isEditable }: IBANFieldProps) => {
	const isFieldEditable = useMemo(
		() => isEditable && hasPermissions(viewSensitiveDataFullPermissionSet),
		[isEditable],
	);

	return (
		<FieldWithReadOnlyMode
			label="IBAN Account Number"
			component={CustomInput}
			smLabel={5}
			smSelect={7}
			type="text"
			validate={[required]}
			name={"iban"}
			blurLoading={loading}
			normalize={normalizeAll([exactNumberOfDigitsMask34])}
			normalizeOnBlur={trimNormalizer}
			readOnlyProps={{
				isEditable: isFieldEditable,
				value,
			}}
		/>
	);
};

const component = memo(IBANField);
export { component as IBANField };
